import {
    FETCH_DATA_PROFILE_REQUEST,
    FETCH_DATA_PROFILE_SUCCESS,
    FETCH_DATA_PROFILE_FAILURE,
    SET_PROFILE
} from '../../actions/profile/profile-actions';

const initialState = {
    profile: {},
    isLoading: false,
    error: null,
};

const ProfileReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DATA_PROFILE_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DATA_PROFILE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                profile: { ...action.payload },
            };
        case SET_PROFILE:
            return {
                ...state,
                isLoading: false,
                profile : { ...action.payload[0] },
            }
        case FETCH_DATA_PROFILE_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default ProfileReducer;